import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import HotelSelectInput from 'legacy-modules/master/hotel/components/select-input';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsHotelTable from './addons-hotel';
import GuestHotelTable from './guest-hotel';
import InformationHotelTable from './information-hotel';

interface Props {
  refund?: RefundModel;
}

export default function HotelPurchaseSection(props: Props) {
  const { control, setValue } = useFormContext();

  const name = 'hotelPurchases';

  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      {fields.map((field, index) => {
        return (
          <Separator key={field.customId} gap={24} direction="vertical">
            <CardSection key={field.customId}>
              <FullContainer>
                <SectionContainer>
                  {props.refund ? (
                    <Text variant="LabelMedium">
                      {t('ticketSales:schedule_extra', {
                        extra: index + 1,
                      })}
                    </Text>
                  ) : (
                    <Input
                      type="check-box"
                      name={`hotelPurchases.${index}.isSelected`}
                      label={t('ticketSales:schedule_extra', {
                        extra: index + 1,
                      })}
                    />
                  )}
                  <Input
                    type="text"
                    name={`hotelPurchases.${index}.bookingCode`}
                    label={t('common:booking_code')}
                    labelPlacement={TextLabelPlacementEnum.Left}
                    placeholder={t('common:booking_code')}
                    noMargin
                    disabled
                  />
                </SectionContainer>
                <SectionContainer>
                  <HalfContainer>
                    <HotelSelectInput
                      name={`hotelPurchases.${index}.hotelId`}
                      label={t('common:hotel')}
                      onAfterDetailChange={(hotel) => {
                        setValue(
                          `hotelPurchases.${index}.hotelName`,
                          hotel.name,
                        );
                        setValue(
                          `hotelPurchases.${index}.hotelPhone`,
                          hotel.phone,
                        );
                        setValue(
                          `hotelPurchases.${index}.hotelEmail`,
                          hotel.email,
                        );
                        setValue(
                          `hotelPurchases.${index}.hotelAddress`,
                          hotel.address,
                        );
                        setValue(`hotelPurchases.${index}.defaultCheckInOut`, {
                          in: hotel.checkIn || '',
                          out: hotel.checkOut || '',
                        });
                      }}
                      disabled
                    />
                  </HalfContainer>
                </SectionContainer>
                <SectionContainer>
                  <HalfContainer>
                    <FullContainer
                      $style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FullContainer>
                        <Input
                          type="text"
                          name={`hotelPurchases.${index}.hotelPhone`}
                          label={t('common:phone_number')}
                          disabled
                        />
                      </FullContainer>
                      <Separator gap={16} />
                      <FullContainer>
                        <Input
                          type="email"
                          name={`hotelPurchases.${index}.hotelEmail`}
                          label={t('common:email')}
                          disabled
                        />
                      </FullContainer>
                    </FullContainer>
                  </HalfContainer>
                  <HalfContainer>
                    <Input
                      type="text"
                      name={`hotelPurchases.${index}.hotelAddress`}
                      label={t('common:address')}
                      disabled
                    />
                  </HalfContainer>
                </SectionContainer>
                <HalfContainer>
                  <FullContainer
                    $style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FullContainer>
                      <Input
                        type="text"
                        name={`hotelPurchases.${index}.defaultCheckInOut.in`}
                        label={t('common:check_in')}
                        disabled
                      />
                    </FullContainer>
                    <Separator gap={16} />
                    <FullContainer>
                      <Input
                        type="text"
                        name={`hotelPurchases.${index}.defaultCheckInOut.out`}
                        label={t('common:check_out')}
                        disabled
                      />
                    </FullContainer>
                  </FullContainer>
                </HalfContainer>
                <Separator gap={24} />
                <GuestHotelTable parentIndex={index} />
                <Separator gap={24} />
                <InformationHotelTable parentIndex={index} />
                <Separator gap={24} />
                <AddonsHotelTable parentIndex={index} />
              </FullContainer>
            </CardSection>
          </Separator>
        );
      })}
    </>
  );
}
